import { updateAgencyBasicInfo } from '../agency/asyncThunks';
import { login, verifyEmail } from '../auth/asyncThunks';
import { updateBasicInfo, updateOnboardingType, updateTelegramInfo } from '../influencerRequest/asyncThunks';
import { createMassPayUser, deleteWithdrawalMethod, requestWithdrawal } from '../withdrawal/asyncThunks';
import {
  changePassword,
  deleteAlbumMedia,
  deleteBundle,
  editAlbumMedia,
  editBundle,
  editManualChatTotalSpentThreshold,
  fetchAlbumMedia,
  fetchAssets,
  fetchBundleById,
  fetchInfluencers,
  fetchMediaBundles,
  fetchReferrals,
  fetchUserEarnings,
  fetchUserInfo,
  fetchUserMonthlyEarnings,
  getOrCreateIdVerificationToken,
  handleWithdrawalMethods,
  testVoice,
  updateUserBasicInfo,
  uploadAssistedPhoto,
  uploadAssistedVideo,
  uploadBundle,
  uploadMedia,
  uploadMediaFromDropbox,
  uploadW9Form,
} from './asyncThunks';

export const fetchUserInfoBuilder = builder => {
  builder.addCase(fetchUserInfo.pending, state => {
    state.pending.fetchUserInfo = true;
  });
  builder.addCase(fetchUserInfo.fulfilled, (state, { payload }) => {
    const { user } = payload;
    state.user = user;
    state.pending.fetchUserInfo = false;
  });
  builder.addCase(fetchUserInfo.rejected, state => {
    state.pending.fetchUserInfo = false;
  });
};

export const loginBuilder = builder => {
  builder.addCase(login.fulfilled, (state, { payload }) => {
    const { user } = payload;
    state.user = user;
  });
};

export const changePasswordBuilder = builder => {
  builder.addCase(changePassword.pending, state => {
    state.pending.changePassword = true;
  });
  builder.addCase(changePassword.fulfilled, state => {
    state.pending.changePassword = false;
  });
  builder.addCase(changePassword.rejected, state => {
    state.pending.changePassword = false;
  });
};

export const verifyEmailBuilder = builder => {
  builder.addCase(verifyEmail.fulfilled, (state, { payload }) => {
    state.user = payload.user;
  });
};

export const updateBasicInfoBuilder = builder => {
  builder.addCase(updateBasicInfo.fulfilled, (state, { payload }) => {
    state.user = payload.user;
  });
};

export const updateTelegramInfoBuilder = builder => {
  builder.addCase(updateTelegramInfo.fulfilled, (state, { payload }) => {
    state.user = payload.user;
  });
};

export const fetchUserEarningsBuilder = builder => {
  builder.addCase(fetchUserEarnings.pending, state => {
    state.pending.fetchUserEarnings = true;
  });
  builder.addCase(fetchUserEarnings.fulfilled, (state, { payload }) => {
    const { daily, overview } = payload;
    state.pending.fetchUserEarnings = false;
    state.user.analytics.daily = daily;
    state.user.analytics.overview = overview;
  });
  builder.addCase(fetchUserEarnings.rejected, state => {
    state.pending.fetchUserEarnings = false;
  });
};

export const handleWithdrawalMethodsBuilder = builder => {
  builder.addCase(handleWithdrawalMethods.pending, state => {
    state.pending.handleWithdrawalMethods = true;
  });
  builder.addCase(handleWithdrawalMethods.fulfilled, (state, { payload }) => {
    const { withdrawalMethods } = payload;
    state.user.withdrawalMethods = withdrawalMethods;
    state.pending.handleWithdrawalMethods = false;
  });
  builder.addCase(handleWithdrawalMethods.rejected, state => {
    state.pending.handleWithdrawalMethods = false;
  });
};

export const deleteWithdrawalMethodBuilder = builder => {
  builder.addCase(deleteWithdrawalMethod.fulfilled, (state, { payload }) => {
    const { withdrawalMethods } = payload;
    state.user.withdrawalMethods = withdrawalMethods;
  });
};

export const updateUserBasicInfoBuilder = builder => {
  builder.addCase(updateUserBasicInfo.pending, state => {
    state.pending.updateUserBasicInfo = true;
  });
  builder.addCase(updateUserBasicInfo.fulfilled, (state, { payload }) => {
    state.user = payload.user;
    state.pending.updateUserBasicInfo = false;
  });
  builder.addCase(updateUserBasicInfo.rejected, state => {
    state.pending.updateUserBasicInfo = false;
  });
};

export const requestWithdrawalBuilder = builder => {
  builder.addCase(requestWithdrawal.fulfilled, state => {
    state.user.thisMonthWithdrawals += 1;
    state.user.hasPendingWithdrawal = true;
  });
};

export const fetchInfluencersBuilder = builder => {
  builder.addCase(fetchInfluencers.pending, state => {
    state.fetchInfluencersInfo.pending = true;
  });
  builder.addCase(fetchInfluencers.fulfilled, (state, { payload }) => {
    const { data, total } = payload;
    state.fetchInfluencersInfo.pending = false;
    state.fetchInfluencersInfo.data = data;
    state.fetchInfluencersInfo.total = total;
  });
  builder.addCase(fetchInfluencers.rejected, state => {
    state.fetchInfluencersInfo.pending = false;
  });
};

export const updateAgencyBasicInfoBuilder = builder => {
  builder.addCase(updateAgencyBasicInfo.fulfilled, (state, { payload }) => {
    state.user = payload.user;
  });
};

export const fetchUserMonthlyEarningsBuilder = builder => {
  builder.addCase(fetchUserMonthlyEarnings.pending, state => {
    state.pending.fetchUserMonthlyEarnings = true;
  });
  builder.addCase(fetchUserMonthlyEarnings.fulfilled, (state, { payload }) => {
    state.pending.fetchUserMonthlyEarnings = false;
    state.monthlyInfluencerEarnings = payload.monthlyInfluencerEarnings;
  });
  builder.addCase(fetchUserMonthlyEarnings.rejected, state => {
    state.pending.fetchUserMonthlyEarnings = false;
    state.monthlyInfluencerEarnings = null;
  });
};

export const fetchAlbumMediaBuilder = builder => {
  builder.addCase(fetchAlbumMedia.pending, (state, { meta }) => {
    const page = meta.arg.page;
    if (page === 1) {
      state.fetchAlbumMediaInfo.pending = true;
    } else {
      state.fetchAlbumMediaInfo.fetchMorePending = true;
    }
  });
  builder.addCase(fetchAlbumMedia.fulfilled, (state, { payload }) => {
    const { data, maxReached, page, counts } = payload;
    if (page === 1) {
      state.fetchAlbumMediaInfo.data = data;
      state.fetchAlbumMediaInfo.counts = counts ?? null;
    } else {
      state.fetchAlbumMediaInfo.data = [...state.fetchAlbumMediaInfo.data, ...data];
    }
    state.fetchAlbumMediaInfo.pending = false;
    state.fetchAlbumMediaInfo.fetchMorePending = false;
    state.fetchAlbumMediaInfo.maxReached = maxReached;
  });
  builder.addCase(fetchAlbumMedia.rejected, state => {
    state.fetchAlbumMediaInfo.pending = false;
    state.fetchAlbumMediaInfo.fetchMorePending = false;
  });
};

export const fetchMediaBundlesBuilder = builder => {
  builder.addCase(fetchMediaBundles.pending, state => {
    state.fetchMediaBundlesInfo.pending = true;
  });
  builder.addCase(fetchMediaBundles.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.fetchMediaBundlesInfo.data = data;
    state.fetchMediaBundlesInfo.pending = false;
  });
  builder.addCase(fetchMediaBundles.rejected, state => {
    state.fetchMediaBundlesInfo.pending = false;
  });
};

export const editAlbumMediaBuilder = builder => {
  builder.addCase(editAlbumMedia.pending, state => {
    state.pending.editAlbumMedia = true;
  });
  builder.addCase(editAlbumMedia.fulfilled, (state, { payload }) => {
    const { media } = payload;
    state.fetchAlbumMediaInfo.data = state.fetchAlbumMediaInfo.data.map(albumMedia => {
      if (albumMedia.id === media.id) {
        return media;
      }
      return albumMedia;
    });
    state.pending.editAlbumMedia = false;
  });
  builder.addCase(editAlbumMedia.rejected, state => {
    state.pending.editAlbumMedia = false;
  });
};

export const uploadMediaBuilder = builder => {
  builder.addCase(uploadMedia.pending, state => {
    state.pending.uploadMedia = true;
  });
  builder.addCase(uploadMedia.fulfilled, state => {
    state.pending.uploadMedia = false;
  });
  builder.addCase(uploadMedia.rejected, state => {
    state.pending.uploadMedia = false;
  });
};

export const deleteAlbumMediaBuilder = builder => {
  builder.addCase(deleteAlbumMedia.pending, state => {
    state.pending.deleteAlbumMedia = true;
  });
  builder.addCase(deleteAlbumMedia.fulfilled, (state, { payload }) => {
    const { albumMediaId } = payload;
    state.fetchAlbumMediaInfo.data = state.fetchAlbumMediaInfo.data.filter(d => d.id !== albumMediaId);
    state.pending.deleteAlbumMedia = false;
  });
  builder.addCase(deleteAlbumMedia.rejected, state => {
    state.pending.deleteAlbumMedia = false;
  });
};

export const uploadBundleBuilder = builder => {
  builder.addCase(uploadBundle.pending, state => {
    state.pending.uploadBundle = true;
  });
  builder.addCase(uploadBundle.fulfilled, (state, { payload }) => {
    state.pending.uploadBundle = false;
  });
  builder.addCase(uploadBundle.rejected, state => {
    state.pending.uploadBundle = false;
  });
};

export const fetchBundleByIdBuilder = builder => {
  builder.addCase(fetchBundleById.pending, state => {
    state.pending.fetchBundleById = true;
  });
  builder.addCase(fetchBundleById.fulfilled, (state, { payload }) => {
    state.pending.fetchBundleById = false;
  });
  builder.addCase(fetchBundleById.rejected, state => {
    state.pending.fetchBundleById = false;
  });
};

export const deleteBundleBuilder = builder => {
  builder.addCase(deleteBundle.pending, state => {
    state.pending.deleteBundle = true;
  });
  builder.addCase(deleteBundle.fulfilled, (state, { payload }) => {
    const { bundleId } = payload;
    state.fetchMediaBundlesInfo.data = state.fetchMediaBundlesInfo.data.filter(d => d.id !== bundleId);
    state.pending.deleteBundle = false;
  });
  builder.addCase(deleteBundle.rejected, state => {
    state.pending.deleteBundle = false;
  });
};

export const editBundleBuilder = builder => {
  builder.addCase(editBundle.pending, state => {
    state.pending.editBundle = true;
  });
  builder.addCase(editBundle.fulfilled, (state, { payload }) => {
    const { bundleId, name } = payload;
    state.fetchMediaBundlesInfo.data = state.fetchMediaBundlesInfo.data.map(bundle => {
      if (bundle.id === bundleId) {
        return {
          ...bundle,
          name,
        };
      }
      return bundle;
    });
    state.pending.editBundle = false;
  });
  builder.addCase(editBundle.rejected, state => {
    state.pending.editBundle = false;
  });
};

export const updateOnboardingTypeBuilder = builder => {
  builder.addCase(updateOnboardingType.fulfilled, (state, { payload }) => {
    state.user.onboardingType = payload.onboardingType;
  });
};

export const fetchReferralsBuilder = builder => {
  builder.addCase(fetchReferrals.pending, state => {
    state.pending.fetchReferrals = true;
  });
  builder.addCase(fetchReferrals.fulfilled, state => {
    state.pending.fetchReferrals = false;
  });
  builder.addCase(fetchReferrals.rejected, state => {
    state.pending.fetchReferrals = false;
  });
};

export const uploadW9FormBuilder = builder => {
  builder.addCase(uploadW9Form.pending, state => {
    state.pending.uploadW9Form = true;
  });
  builder.addCase(uploadW9Form.fulfilled, (state, { payload }) => {
    state.user.w9Info = payload.w9Info;
    state.pending.uploadW9Form = false;
  });
  builder.addCase(uploadW9Form.rejected, state => {
    state.pending.uploadW9Form = false;
  });
};

export const uploadAssistedPhotoBuilder = builder => {
  builder.addCase(uploadAssistedPhoto.fulfilled, state => {
    state.user.numOfPhotos += 1;
  });
};

export const uploadAssistedVideoBuilder = builder => {
  builder.addCase(uploadAssistedVideo.fulfilled, state => {
    state.user.numOfVideos += 1;
  });
};

export const fetchAssetsBuilder = builder => {
  builder.addCase(fetchAssets.pending, (state, { meta }) => {
    const page = meta.arg.page;
    if (page === 1) {
      state.fetchAssetsInfo.pending = true;
    } else {
      state.fetchAssetsInfo.fetchMorePending = true;
    }
  });
  builder.addCase(fetchAssets.fulfilled, (state, { payload }) => {
    const { data, maxReached, page } = payload;
    if (page === 1) {
      state.fetchAssetsInfo.data = data;
    } else {
      state.fetchAssetsInfo.data = [...state.fetchAssetsInfo.data, ...data];
    }
    state.fetchAssetsInfo.pending = false;
    state.fetchAssetsInfo.fetchMorePending = false;
    state.fetchAssetsInfo.maxReached = maxReached;
  });
  builder.addCase(fetchAssets.rejected, state => {
    state.fetchAssetsInfo.pending = false;
    state.fetchAssetsInfo.fetchMorePending = false;
  });
};

export const testVoiceBuilder = builder => {
  builder.addCase(testVoice.pending, state => {
    state.pending.testVoice = true;
  });
  builder.addCase(testVoice.fulfilled, state => {
    state.pending.testVoice = false;
  });
  builder.addCase(testVoice.rejected, state => {
    state.pending.testVoice = false;
  });
};

export const createMassPayUserBuilder = builder => {
  builder.addCase(createMassPayUser.fulfilled, (state, { payload }) => {
    const { status, email } = payload;
    state.user.massPay.status = status;
    state.user.massPay.email = email;
  });
};

export const editManualChatTotalSpentThresholdBuilder = builder => {
  builder.addCase(editManualChatTotalSpentThreshold.pending, state => {
    state.pending.editManualChatTotalSpentThreshold = true;
  });
  builder.addCase(editManualChatTotalSpentThreshold.fulfilled, state => {
    state.pending.editManualChatTotalSpentThreshold = false;
  });
  builder.addCase(editManualChatTotalSpentThreshold.rejected, state => {
    state.pending.editManualChatTotalSpentThreshold = false;
  });
};

export const uploadMediaFromDropboxBuilder = builder => {
  builder.addCase(uploadMediaFromDropbox.pending, state => {
    state.pending.uploadMediaFromDropbox = true;
  });
  builder.addCase(uploadMediaFromDropbox.fulfilled, state => {
    state.pending.uploadMediaFromDropbox = false;
  });
  builder.addCase(uploadMediaFromDropbox.rejected, state => {
    state.pending.uploadMediaFromDropbox = false;
  });
};

export const getOrCreateIdVerificationTokenBuilder = builder => {
  builder.addCase(getOrCreateIdVerificationToken.pending, state => {
    state.pending.getOrCreateIdVerificationToken = true;
  });
  builder.addCase(getOrCreateIdVerificationToken.fulfilled, state => {
    state.pending.getOrCreateIdVerificationToken = false;
  });
  builder.addCase(getOrCreateIdVerificationToken.rejected, state => {
    state.pending.getOrCreateIdVerificationToken = false;
  });
};
